var mp = mp || {};

// AJAX loading content for documents
//----------------------------------------------------------
mp.ajaxFormSubmit = function() {
    var $element = $('.ajaxFormSubmit');

    if (!$element.length) {
        return;
    }

    var $form = $element.parents('form');
    var $content = $form.next('.ajaxContent');

    // Watcher for click events in dropdown
    $element.on('change', function() {
        $form.submit();
    });

    // Init submit



    // Form submission
    $form.on('submit', function(e){
        e.preventDefault();

        var $thisForm = $(this),
            $canBeLoaded = true; // this param allows to initiate the AJAX call only if necessary

        if( $canBeLoaded == true ){
            $.ajax({
                url: ajax_object.ajax_url,
                data: $thisForm.serialize(), 
                type: $thisForm.attr('method'),

                beforeSend:function(xhr){
                    $canBeLoaded = false;
                    $content.html('<div class="preloader"><div class="preloader__icon"></div></div>');
                },

                success: function(data) {
                    if (data) {
                        $canBeLoaded = true; // the ajax is completed, now we can run it again
                        $content.html(data);
                    }
                },

                error : function(jqXHR) {
                    // console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
            });
        };
    });
};


$(document).ready(function(){
    mp.ajaxFormSubmit();
});